var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"patient-consent-wrapper"},[_c('rp-consent',{staticClass:"patient-consent"}),_vm._v(" "),_c('rp-button',{attrs:{"type":"primary"},on:{"click":_vm.onConfirm}},[_vm._v("Confirm")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4baed33c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Patients/PatientConsent.vue
// module id = null
// module chunks = 